import { createFileRoute } from '@tanstack/react-router'

import { RetentionSettingsPage } from '@/features/settings/section-pages'

export const Route = createFileRoute('/_app/settings/retention')({
  component: RetentionSettingsPage,
})
